import { render, staticRenderFns } from "./publishSuccess.vue?vue&type=template&id=337b74a0&scoped=true&"
import script from "./publishSuccess.vue?vue&type=script&lang=js&"
export * from "./publishSuccess.vue?vue&type=script&lang=js&"
import style0 from "./publishSuccess.vue?vue&type=style&index=0&id=337b74a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337b74a0",
  null
  
)

export default component.exports